import { connect, MapDispatchToProps } from 'react-redux';
import { Props } from './CommissionStatusButton';
import { changeCommissionStatus } from '../../../redux/commissions/actionCreators';

export type DispatchProps = Pick<Props, 'onClick'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onClick: changeCommissionStatus,
};

export default connect(null, mapDispatchToProps);
